import { apiProvider } from "./core/provider";

const apiOrchidFeedback = {};

apiOrchidFeedback.lookup = function (policyNo) {
  return apiProvider.list("orchid-feedback/lookup", { policyNo });
};

apiOrchidFeedback.options = function () {
  return apiProvider.list("orchid-feedback/options");
};

apiOrchidFeedback.listIssues = function (params) {
  return apiProvider.list("orchid-feedback/issues", params);
};

apiOrchidFeedback.createIssues = function (policyNo, issues) {
  return apiProvider.post("orchid-feedback/issues", { policyNo, issues });
};

apiOrchidFeedback.parseFeedback = function (text, reportDate) {
  return apiProvider.post("orchid-feedback/parse", { text, reportDate });
};

apiOrchidFeedback.updateIssue = function (id, issue) {
  return apiProvider.put(`orchid-feedback/issues/${id}`, issue);
};

apiOrchidFeedback.deleteIssue = function (id) {
  return apiProvider.delete("orchid-feedback/issues", id);
};

apiOrchidFeedback.stats = function (params) {
  return apiProvider.list("orchid-feedback/stats", params);
};

apiOrchidFeedback.reportDates = function () {
  return apiProvider.list("orchid-feedback/report-dates");
};

apiOrchidFeedback.listPhotoSections = function (includeInactive) {
  return apiProvider.list("orchid-feedback/photo-sections", includeInactive ? { includeInactive: "true" } : undefined);
};

apiOrchidFeedback.createPhotoSection = function (name, active, position) {
  return apiProvider.post("orchid-feedback/photo-sections", { name, active, position });
};

apiOrchidFeedback.updatePhotoSection = function (id, name, active, position) {
  return apiProvider.put(`orchid-feedback/photo-sections/${id}`, { name, active, position });
};

apiOrchidFeedback.deletePhotoSection = function (id) {
  return apiProvider.delete("orchid-feedback/photo-sections", id);
};

export { apiOrchidFeedback };